const approvedPosition = {
  BUSINESS_CONSULTANT_VALUE: 1,
  PROJECT_MANAGER_VALUE: 2,
  BUSINESS_CONSULTANT_EXTRA_VALUE: 3,
  PROJECT_MANAGER_EXTRA_VALUE: 4
}

export default approvedPosition



// WEBPACK FOOTER //
// ./src/constants/approvedPosition.js